import { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from '../src/components/Navbar/Navbar';
import Sidebar from '../src/components/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import Ls1Home from '../src/Pages/Ls1Home/Ls1Home';
import Ls2BebePrematuro from '../src/Pages/Ls2BebePrematuro/Ls2BebePrematuro';
import Ls3RiesgosRespiracion from '../src/Pages/Ls3RiegosRespiracion/Ls3RiegosRespiracion';
import Ls4RiesgosInfecciones from './Pages/Ls4RiesgosInfecciones/Ls4RiesgosInfecciones';
import Ls5BronquiolitisSintomas from './Pages/Ls5BronquiolitisSintomas/Ls5BronquiolitisSintomas';
import Ls6BronquiolitisAlarma from './Pages/Ls6BronquiolitisAlarma/Ls6BronquiolitisAlarma';
import Ls7PrevencionVSR from './Pages/Ls7PrevencionVSR/Ls7PrevencionVSR';
import Ls8Hospital from './Pages/Ls8Hospital/Ls8Hospital';
import Ls9CasaIgiene from './Pages/Ls9CasaIgiene/Ls9CasaIgiene';
import Ls10CasaVisitas from './Pages/Ls10CasaVisitas/Ls10CasaVisitas';
import Ls11Alimentacion from './Pages/Ls11Alimentacion/Ls11Alimentacion';
import Ls12PosicionesSacarGases from './Pages/Ls12PosicionesSacarGases/Ls12PosicionesSacarGases';
import Ls13DulceSuenos from './Pages/Ls13DulceSuenos/Ls13DulceSuenos';
import Ls14AsearBebe from './Pages/Ls14AsearBebe/Ls14AsearBebe';
import Ls15DisfrutarTiempo from './Pages/Ls15DisfrutarTiempo/Ls15DisfrutarTiempo';
import PagesData from './Utils/PagesData';
import './App.scss';

class App extends Component {

  state = {
    pagesData: PagesData,
    currentPreviewPage: 0
  }

  onCurrentPageClick = (pos) => {
    this.setState({ currentPreviewPage: pos });
  }

  render() {
    return (
      <>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <div className='container-fluid p-0 d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls1Home />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 0}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-2"
            element={
              <>
                <Navbar />
                <div className='container-fluid p-0 d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls2BebePrematuro />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 1}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-3"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls3RiesgosRespiracion />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 2}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-4"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls4RiesgosInfecciones />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 3}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-5"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls5BronquiolitisSintomas />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 4}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-6"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls6BronquiolitisAlarma />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 5}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-7"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls7PrevencionVSR />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 6}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-8"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls8Hospital />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 7}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-9"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls9CasaIgiene />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 8}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-10"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls10CasaVisitas />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 9}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-11"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls11Alimentacion />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 10}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-12"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls12PosicionesSacarGases />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 11}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-13"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls13DulceSuenos />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 12}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-14"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls14AsearBebe />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 13}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/lesson-15"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <div className='container-fluid p-0 template--main'>
                    <Ls15DisfrutarTiempo />
                    <Footer
                      currentPreviewPage={this.state.currentPreviewPage = 14}
                      previousLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].previous}
                      nextLessonName={this.state.pagesData.pageOptions[this.state.currentPreviewPage].next}
                      onCurrentPageClick={this.onCurrentPageClick}
                      data={this.state.pagesData}
                    />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="*"
            element={
              <>
                <Navbar />
                <div className='d-flex'>
                  <Sidebar />
                  <ErrorPage />
                </div>
              </>
            }
          />
        </Routes>
      </>
    );
  }
}

export default App;
